import type { QuickFilter } from "../../../DataTable-modular/types";
import { COMMON_QUICK_FILTERS } from "../common/common-quick-filters";

// ============================================================================
// TICKET QUICK FILTERS
// ============================================================================

// Ticket specific quick filters
export const TICKET_QUICK_FILTERS: QuickFilter[] = [
  COMMON_QUICK_FILTERS.client,
  {
    id: "status",
    label: "Status",
    type: "select" as const,
    field: "status",
    placeholder: "Select status...",
    options: [
      { label: "New", value: "new" },
      { label: "Assigned", value: "assigned" },
      { label: "In Progress", value: "in_progress" },
      { label: "Waiting for Customer", value: "waiting_for_customer" },
      { label: "Waiting for Vendor", value: "waiting_for_vendor" },
      { label: "Resolved", value: "resolved" },
      { label: "Closed", value: "closed" },
      { label: "Cancelled", value: "cancelled" },
    ],
  },
  {
    id: "priority",
    label: "Priority",
    type: "select" as const,
    field: "priority",
    placeholder: "Select priority...",
    options: [
      { label: "Low", value: "low" },
      { label: "Medium", value: "medium" },
      { label: "High", value: "high" },
      { label: "Critical", value: "critical" },
      { label: "Urgent", value: "urgent" },
    ],
  },
  COMMON_QUICK_FILTERS.user,
  COMMON_QUICK_FILTERS.ticketNumber,
  {
    id: "title",
    label: "Title",
    type: "text" as const,
    field: "title",
    placeholder: "Search title...",
  },
];
